/* Strawhat: keeps Your Pour cart lines together (Phase 2 Step 3). Loaded by snippets/cart-drawer.liquid and
   sections/main-cart-items.liquid.
   A pour is 3 kinds of lines sharing one hidden _pour_id (the Design Code):
   - the pour itself (Your Pour by Strawhat, quantity = packs; the customer changes or removes it)
   - one Design Fee line (always quantity 1 while any pack of that design is in the cart)
   - Add-On lines (quantity = packs x the hidden _per_pack count). The Extra Dye add-on was dropped on 2026-10-05
     (extra dyes are free now; max 3 dyes stays), so an Extra Dye line left in an older cart is removed.
   After any cart change this checks those rules and fixes the cart in one update, then redraws the drawer,
   cart page and header count. It also removes fee or add-on lines left without a pour, and pour lines that
   weren't built on the Your Pour page (no _pour_id). Shopify Flow is the backstop on orders (Step 9).
   v2.1.1: Shopify's "Buy again" (customer account → Orders) re-adds an order's lines WITHOUT their properties, so a
   Your Pour pack comes back with no design. When this script removes such a pack, it sends the customer to Your
   Pours (?from=buy-again&v=<variant ids>), where the matching pour is highlighted and Pour It Again ($5) is one tap.
   Anything else from that order stays in the cart. */
(() => {
  if (window.__shPourCart) return;
  window.__shPourCart = true;
  const H = { pour: 'your-pour-by-strawhat', fee: 'your-pour-design-fee', add: 'your-pour-add-on' };
  const CFG = window.shPourCart || {};
  let busy = false, again = false;

  // Put each pour's fee and add-on rows right under it (drawer and cart page). No-JS order is Shopify's own.
  function order() {
    if (!document.querySelector('tr[data-pour-role]')) return;
    document.querySelectorAll('.cart-items tbody, cart-drawer-items tbody').forEach((tb) => {
      tb.querySelectorAll('tr[data-pour-role="pour"]').forEach((pour) => {
        const id = pour.dataset.pourId;
        let last = pour;
        while (last.nextElementSibling && last.nextElementSibling.dataset.pourId === id && last.nextElementSibling.dataset.pourRole === 'pour') last = last.nextElementSibling;
        tb.querySelectorAll(`tr[data-pour-role="sub"]`).forEach((sub) => {
          if (sub.dataset.pourId !== id) return;
          if (last.nextElementSibling !== sub) last.after(sub);
          last = sub;
        });
      });
    });
  }

  function sectionsOnPage() {
    const els = [document.querySelector('cart-drawer-items'), document.querySelector('cart-items:not(cart-drawer-items)')].filter((el) => el && typeof el.getSectionsToRender === 'function');
    const list = [];
    els.forEach((el) => { try { el.getSectionsToRender().forEach((s) => { if (s.section && !list.some((x) => x.section === s.section && x.id === s.id)) list.push(Object.assign({ el }, s)); }); } catch (e) {} });
    return list;
  }
  function paint(state, list) {
    const empty = state.item_count === 0;
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', empty);
    const foot = document.getElementById('main-cart-footer');
    if (foot) foot.classList.toggle('is-empty', empty);
    const page = document.querySelector('cart-items:not(cart-drawer-items)');
    if (page) page.classList.toggle('is-empty', empty);
    list.forEach((s) => {
      const html = state.sections && state.sections[s.section];
      const host = document.getElementById(s.id);
      if (!html || !host) return;
      const target = host.querySelector(s.selector) || host;
      const src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      if (src) target.innerHTML = src.innerHTML;
    });
    order();
  }
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());

  async function sync() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      const cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      const groups = {};
      cart.items.forEach((it) => {
        const kind = it.handle === H.pour ? 'pour' : it.handle === H.fee ? 'fee' : it.handle === H.add ? 'add' : '';
        if (!kind) return;
        const id = (it.properties && it.properties._pour_id) || '';
        const g = (groups[id] = groups[id] || { pour: [], fee: [], add: [] });
        g[kind].push(it);
      });
      const updates = {};
      const addFee = [];
      let lost = []; // Your Pour packs with no design (e.g. from Shopify's Buy Again)
      Object.entries(groups).forEach(([id, g]) => {
        if (!id) { g.pour.concat(g.fee, g.add).forEach((it) => { updates[it.key] = 0; }); lost = g.pour.map((it) => it.variant_id); return; } // not built on the Your Pour page
        const packs = g.pour.reduce((a, it) => a + it.quantity, 0);
        g.fee.forEach((it, i) => { const want = packs && i === 0 ? 1 : 0; if (it.quantity !== want) updates[it.key] = want; });
        const seen = new Set(); // one line per add-on per pour; a stray duplicate goes to 0
        g.add.forEach((it) => { const want = seen.has(it.variant_id) || it.variant_title === 'Extra Dye' ? 0 : packs * Math.max(1, parseInt(it.properties._per_pack, 10) || 1); seen.add(it.variant_id); if (it.quantity !== want) updates[it.key] = want; });
        if (packs && !g.fee.length && CFG.fee) {
          const p = g.pour[0].properties || {};
          addFee.push({ id: CFG.fee, quantity: 1, properties: { For: (p['Pour Name'] ? p['Pour Name'] + ' · ' : '') + id, _pour_id: id } });
        }
      });
      if (!Object.keys(updates).length && !addFee.length) { order(); return; }
      const list = sectionsOnPage();
      const sections = [...new Set(list.map((s) => s.section))].slice(0, 5);
      let state;
      if (Object.keys(updates).length) state = await post('/cart/update.js', { updates, sections, sections_url: location.pathname });
      if (addFee.length) {
        await post('/cart/add.js', { items: addFee });
        state = await post('/cart/update.js', { updates: {}, sections, sections_url: location.pathname });
      }
      if (state && !state.status) paint(state, list);
      if (lost.length && CFG.pours && !/your-pours/.test(location.pathname + location.search)) {
        const left = state && !state.status ? state.item_count : 0;
        location.assign(CFG.pours + (CFG.pours.includes('?') ? '&' : '?') + 'from=buy-again&v=' + [...new Set(lost)].join(',') + (left ? '&kept=1' : ''));
      }
    } catch (e) {
      // Leave the cart as Shopify has it; Flow tags any order with a missing or extra fee for Johnny.
    } finally {
      busy = false;
      if (again) { again = false; sync(); }
    }
  }
  window.shPourSync = sync;

  const start = () => {
    order();
    sync();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => sync());
    // Dawn swaps the drawer and cart contents after its own changes; keep the rows grouped.
    new MutationObserver(() => order()).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
